<svelte:options
        customElement={{tag: "ft9-benefit-activation-snackbar-v1"}}
/>

<script lang="ts">
    import { onMount, onDestroy } from "svelte";
    import {ActivationTrigger, type BenefitEvents, benefitEvents} from "@otto-ec/nexus-registry/benefit/events";
    import { submitEventMerge } from "@otto-ec/tracking-bct";
    import type {Unset, NexusExtractSignalPayload} from "@otto-ec/global-resources/nexus"

    type ActiveEventPayload = NexusExtractSignalPayload<BenefitEvents["active"]>;

    type ActivatedBenefit = {
        id: string;
        eventMergeId: string | undefined;
        count: number;
    }

    let activatedBenefits = $state(new Array<ActivatedBenefit>());
    let snackbarEl: HTMLOcSnackbarV1Element;
    let unset: Unset;

    onMount(() => {
        unset = benefitEvents.active.subscribe((event: ActiveEventPayload) => {
            const activatedId = event.frameId ?? event.id;

            /*                                                                     */
            if (!event.active) {
                let i = activatedBenefits.findIndex(benefit => benefit.id === activatedId);
                activatedBenefits.splice(i, 1);
                return;
            }

            switch (event.trigger) {
                case ActivationTrigger.ACTIVATED_BY_USER:
                    if (!activatedBenefits.some(benefit => benefit.id === activatedId)) {
                        activatedBenefits.push({
                            id: activatedId,
                            /*                                                    */
                            eventMergeId: event.eventMergeId,
                            count: 1,
                        });
                        /*                                                                              */
                        setTimeout(() => {
                            sendTracking(activatedId)
                        }, 200)
                    }
                    break;
                case ActivationTrigger.ACTIVATED_ON_OTHER_VARIATION:
                    /*                                                     */
                    /*                                                                                                  */
                    /*                                                                                                           */
                    activatedBenefits.map(benefit => { if (benefit.id === activatedId) { benefit.count++; }});
                    break;
                default:
                    /*                                                                 */
                    return;
            }

            const activatedBenefit = activatedBenefits.find(benefit => benefit.id === activatedId);

            if (activatedBenefit && activatedBenefit.count > 1) {
                snackbarEl.open = true;
                snackbarEl.message = `Rabatt für ${activatedBenefit.count} gemerkte Artikel aktiviert.`
            }
        })
    })
    onDestroy(() => {
        /*          */
        unset();
    })

    const sendTracking = (activatedBenefitId: string) => {
        const activatedBenefit = activatedBenefits.find(benefit => benefit.id === activatedBenefitId);
        if (activatedBenefit && activatedBenefit.eventMergeId) {
            submitEventMerge(activatedBenefit.eventMergeId, {wishlist_BenefitActivationCount: [`${activatedBenefit.count}`]});
        }
    }

</script>

<oc-snackbar-v1 bind:this={snackbarEl} message=""></oc-snackbar-v1>
